import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=22504c7b&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22504c7b')) {
      api.createRecord('22504c7b', component.options)
    } else {
      api.reload('22504c7b', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=22504c7b&", function () {
      api.rerender('22504c7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AVpQUHP1xxA0/JS/comp/FavElement.vue"
export default component.exports